import { render, staticRenderFns } from "./Booter.vue?vue&type=template&id=4976df74&scoped=true&"
import script from "./Booter.vue?vue&type=script&lang=js&"
export * from "./Booter.vue?vue&type=script&lang=js&"
import style0 from "./Booter.vue?vue&type=style&index=0&id=4976df74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4976df74",
  null
  
)

export default component.exports